import { Trash2, X } from 'lucide-react'
import { useEditorStore } from '../../../store/editorStore'
import { Button } from '../../common/Button'
import { OVERLAY_KIND_LABEL } from './overlayMeta'

/** task spec §3-5: 複数選択時は件数と内訳、「まとめて削除」だけを表示する。 */
export function MultiSelectionInspector() {
  const selectedIds = useEditorStore((s) => s.selectedIds)
  const composition = useEditorStore((s) => s.composition)
  const removeSelected = useEditorStore((s) => s.removeSelected)
  const clearSelection = useEditorStore((s) => s.clearSelection)

  if (!composition) return null

  const counts: Record<string, number> = {}
  for (const item of selectedIds) {
    let label: string
    if (item.kind === 'segment') label = 'クリップ'
    else if (item.kind === 'audio') label = '音声'
    else {
      const overlay = composition.tracks.overlays.find((o) => o.id === item.id)
      label = overlay ? OVERLAY_KIND_LABEL[overlay.kind] : 'Overlay'
    }
    counts[label] = (counts[label] ?? 0) + 1
  }
  const summary = Object.entries(counts)
    .map(([label, n]) => `${label} ${n}`)
    .join('・')

  return (
    <div className="p-3 space-y-4" data-testid="multi-selection-inspector">
      <div className="flex items-center justify-between">
        <div className="text-xs font-semibold">{selectedIds.length} 件選択中</div>
        <button
          onClick={clearSelection}
          className="text-text-faint hover:text-text p-1"
          title="選択解除"
          data-testid="multi-selection-close"
        >
          <X size={14} />
        </button>
      </div>
      <div className="text-xs text-text-muted" data-testid="multi-selection-summary">
        {summary}
      </div>
      <Button
        variant="danger"
        size="sm"
        className="w-full"
        icon={<Trash2 size={13} />}
        onClick={removeSelected}
        data-testid="multi-selection-remove"
      >
        まとめて削除（{selectedIds.length}）
      </Button>
    </div>
  )
}
